import default_list_actions from '@/components/info/js/default_list_actions.js'
import record  				from '@/components/sounds/record.vue'

export default {
	name 		: "management_incident",
	props 		: [
		"info_to_component",
		"ref_to_component",
	],
	components 	: {
		record,
	}, // components
	data : (vm) =>({
		list_actions 	: [],
		loading_reports : false, 
		head_incident 	: {	
			class_card  	: "mx-1 ",
			title  			: 'magament_incidents',
			class_title  	: "caption secondary pa-0 pl-0",
			class_subtitle  : "ma-0 pa-0", // d-flex justify-space-between
			class_actions 	: "pa-1",
			text_btn 		: vm.$ml.get("new"),
			icon_state 		: true,
			action_btn 		: 'show_add',
			action_btn1  	: "",
			icon_h 			: "20", 
			icon_w 			: "20",
			icon_class  	: "mt-1 ml-1",
			color_confirm  	: "success",
			class_confirm  	: "mt-1 ml-1",
			confirm_action 	: "confirm_confirm_alert",
			text_confirm    : vm.$ml.get("confirm_alert"),
			color_false_positive  	: "warning",
			class_false_positive  	: "ma-1",
			action_false_positive 	: "confirm_false_positive",	
			text_false_positive  	: vm.$ml.get("false_positive"),
		},
		info_incident  	:  {
			action 	 		: "",
			descriptions 	: [],
			comments 		: [],
			description 	: "",

		},
		info_item  		: {},
		info_component  : null,
		description 	: "",
		list 			: [],
		show 			: {
			actions 		: false,
			descriptions 	: false,
			table 			: true,
			name_incident 	: false,
			confirm  		: true,
			false_positive  : true,
			ignore  		: true,
		},
		header_table  		: [
			{ text : "name", value : "name" },
			{ text : "options", value : "options" },
		],
		layout_height 		: 200,
		options 			: { itemsPerPage : 30 },
		total 				: 0,
		ID_notification 	: "management_incident",
		bus 				: {},
		list_options 		: [
			{
				key 	: "options",
				options : [
					{
						key 	: "descriptions",
						icon 	: "mdi-view-list-outline",
						color 	: "primary",
						action 	: "select_incident",

					}
				] 
			}
		] 
	}), // data

	watch : {

	}, // watch

	created(){
	    this.render_list_actions();
	    this.ID_notification += this.ref_to_component;
	    // console.log("Check notifications_modal id management_incident ", this.ID_notification)
	    if (this.info_to_component) {
			this.render_info(this.info_to_component);

	    	// this.get_actions_reports(this.info_to_component);
	    }
	}, // created

	watch : {
		info_to_component(val){
			// console.log("get list incident ********************************", val);
			this.render_info(val);
		}, // info_to_component

	}, // watch

	computed : {
		render_list : function(){
			return this.list;
		}, 

	}, // computed

	methods : {
		actions_to_report(act, item, opt){
				console.log("actions incident_to_report : action " , act, "\n item ",item, "\n option : ", opt)
				if (act == 'ignore') {
					this.ignore_alert();					
					// this.send_action()
				}else if(act == "send_comment"){
					this.action_descriptions(item);

				}else if(act == "show_add"){
					this.head_incident.icon_state = !this.head_incident.icon_state;
					if (this.head_incident.action_btn1 == "close_descriptions") {
						this.head_incident.action_btn1 	= "";
						this.show.descriptions 			= false;
						this.show.actions 				= false;
						this.show.table 				= true;
						this.head_incident.text_btn 	= this.$ml.get("new");

					}else{

						if (!this.head_incident.icon_state) {

							this.info_item 	= {...this.list_actions[0]}; // { ...item }
							item 			= {...this.list_actions[0]};
							if (item && item.options) {

								this.$EventBus.$emit('notifications_modal', {
									type 	: "confirm_options",
									options : item.options,
									ID 		: this.ID_notification,
								})
							}else{
								console.warn("Required Options to report incident ", item);
							}
						}
					}
				}
				else if(act == "download_pdf"){
					// Lazy load PDF functionality
					this.$loadPdf().then(async (pdfInstance) => {
						try {
							await pdfInstance.download_pdf_async();
						} catch (error) {
							console.error('Error generating PDF:', error);
							this.$EventBus.$emit('notifications_modal', {
								type: 'error',
								message: 'Error generating PDF'
							});
						}
					}).catch(error => {
						console.error('Error loading PDF module:', error);
						this.$EventBus.$emit('notifications_modal', {
							type: 'error',
							message: 'Error loading PDF functionality'
						});
					});
				}else if(act == "select_incident" || act.action == "select_incident"){
					if (item && item.descriptions &&  item.descriptions.length > 0 ) {
						item.descriptions.forEach((desp) => {
							let temp = this.$Format.render_incident_desciption(desp);
							console.log("Convert descriptions ", temp)
							if (temp) {
								desp = temp;
							}
						});
						item.descriptions.sort((a,b)=> {
							return   new Date(b.datee) - new Date(a.datee);
						})
					}
					// console.log("CHECK ITEM incident : ", item);
					this.info_incident 				= { ...item };
					this.show.descriptions 			= true;
					this.show.actions 				= true;
					this.show.table 				= false;
					this.head_incident.icon_state 	= false; 
					this.head_incident.action_btn1 	= "close_descriptions";
					this.head_incident.text_btn 	= this.$ml.get("close_descriptions");
					
				}else
				if (act == "confirm_confirm_alert") {
					this.$EventBus.$emit('notifications_modal', {
						type 	: "confirm_options",
						message : this.$ml.get("confirm_alert"),
						action 	: {
							action : "confirm_alert",
						},
						ID 		: this.ID_notification,
						no_msg_default : true,
					})
				} 
				else
				if (act == "confirm_alert") {
					this.confirm_alert();
				}else 
				if (act == "confirm_false_positive") {
					this.$EventBus.$emit('notifications_modal', {
						type 	: "confirm_options",
						message : this.$ml.get("false_positive"),
						action 	: {
							action : "false_positive",
						},
						ID 		: this.ID_notification,
						no_msg_default : true,
					})
				}else
				if( act == "false_positive"){
					this.send_false_positive();
				}else 
				if (act == "confirm_ignore") {
					this.$EventBus.$emit('notifications_modal', {
						type 	: "confirm_options",
						message : this.$ml.get("ignore_alert"),
						action 	: {
							action : "ignore",
						},
						ID 		: this.ID_notification,
						no_msg_default : true,
					})
				}
				else if(act == "default"){
					console.log("action report ", item)
					this.action_report(item);
				}else if (act == "send_bus_info_to_table") {					
					if (this.info_component && this.info_component.ID) {						
						item['id'] = this.info_component.ID;
						this.$EventBus.$emit("update_table_" + this.ref_to_component, item);
					}
				}
			}, // action to report

			render_info(val){
				if (val){
					this.list 					= [];
					this.total 					= 0;
					this.info_component 		= { ...val };
					let is_incident 			= false; 			
					// console.log("info component ", this.info_component)
					if (val && val.Management_incident && val.Management_incident.length > 0) {
						this.list 	= [ ...val.Management_incident ];
						this.total 	= this.list.length;
						// is_incident = true;
					}else
					if (val && val.original_source && val.original_source.Management_incident && val.original_source.Management_incident.length > 0) {
						let list_temp 	= [];
						val.original_source.Management_incident.forEach((incd)=>{
							let tmp = this.$Format.render_incident(incd);
							if (tmp) {
								list_temp.push(tmp);
							}
						});
						// is_incident = true;						
						this.list 	= [ ...list_temp ];
						this.total 	= this.list.length;
					}
					this.info_incident 			= {
						action 	 		: "",
						descriptions 	: [],
						description 	: "",
					};
					this.show.confirm 				= true;			
					this.show.ignore  				= true;
					this.show.false_positive 		= true;	
					this.show.table 				= true;								 
					this.head_incident.icon_state 	= this.head_incident.icon_state ? true : true;
					this.show.actions				= false;
					if (this.head_incident.action_btn1 == "close_descriptions") {
						this.actions_to_report("show_add");
					}

					if (val.alert_confirmed || val.isignored || val.false_positive || is_incident) {
						this.show.confirm 			= false;
						this.show.ignore  			= false;
						this.show.false_positive 	= false;
					}else{
						if (['technical', 'peripherals', 'audios', 'lpr', 'parking', 'face', 
							'motion', 'objects', 'actions', 'incidents', 'face_detected', 
							'face_recognized', 'avc'].includes(val.analytic)) {
							this.show.confirm 			= false;
							this.show.ignore  			= false;
							this.show.false_positive 	= false;
						}
						if (val.analytic != 'alarms') {
							this.show.confirm 			= false;
							this.show.ignore  			= false;
						}
					}

				}else{
					this.info_incident 			= {
						action 	 		: "",
						descriptions 	: [],
						description 	: "",
					};
					// this.info_component 		= null;
					this.show.table 			= true;								 
					this.show.confirm 			= true;				
					this.show.ignore  			= true;
					this.show.false_positive 	= true;
					this.head_incident.text_btn = this.$ml.get("new");

				}
			}, // render info

			action_report(item){
				console.log("incident_to_report post : ", item)
				let url 			 			= this.$URL + "/api/v1/management_incident";
				this.loading_reports 			= true;
				let info_up 		 			= { ...item };
				let temp_user 					= this.$store.getters["auth/user"];
				// console.log("USER **************************", temp_user, temp_user.user);
				info_up.userId  				= temp_user && temp_user.user && temp_user.user ? temp_user.user.id : null ;
				info_up.username  				= temp_user && temp_user.user && temp_user.user ? temp_user.user.Username : null ;

				if (this.info_to_component) {

					info_up.eventId				= this.info_to_component.ID
					info_up.deviceId 			= this.info_to_component.deviceId;
					info_up.type 				= this.info_to_component.analytic;
				}
				info_up.priority 				= 1;	
				info_up.state 					= "active";
				/*{
					
					type  			: "",
					// descriptions 	: [],
					description 	: item.text,
				}*/ 
				
				/*this.info_incident["descriptions"]	= [
						{
							id 		 : 1,
							username : "lex",
							description  : "Robo en tienda local",
							date     : this.$Format.format_date(new Date(), "createdAt"), 
						},
						{
							id 		 : 2,
							username : "marx",
							description  : "Sospecho capturado por robo en tienda local",
							date     : this.$Format.format_date(new Date(), "createdAt"), 
						},
						{
							id 		 : 3,
							username : "marx",
							description  : "Sospecho entregado a policia local",
							date     : this.$Format.format_date(new Date(), "createdAt"), 
						},
					] */
				
				this.$axios.post(url, info_up).then(res =>{
					this.loading_reports 	= false;
					// console.log("RES INCIDENT *************************", res)
					if (res && res.data && res.data.id){
						info_up.id   = res.data.id;
						info_up.date = res.data.date;
						info_up.datee = this.$Format.format_date(parseInt(info_up.date));
						// this.show.descriptions 			= true; // incident_to_report
						// this.show.actions 				= true;
						// this.show.table 				= false; 
						// this.head_incident.icon_state   = false;s
						// this.show.confirm 				= false;
						// this.show.ignore  				= false;
						// this.show.false_positive 		= false;
						/*this.info_component.alert_confirmed = true;
						this.info_component.isignored 		= true;*/
							// this.info_component.is_confirmed 	= this.$ml.get("confirmed");
						// this.info.reports 				= true;					
						// this.render_cols("reports"); 
						this.info_incident 				= {...info_up};
						info_up.action 					= "select_incident";
						let action_temp 				= "N/A";												
						if (res.data.descriptions && res.data.descriptions.length > 0) {
							info_up.descriptions = [...res.data.descriptions];				
							if (info_up.descriptions[0]) {
								action_temp  = info_up.descriptions[0].description;
							}				
						}
						// console.log("RESULT -------------__> ", info_up)
						this.info_incident.descriptions = [{ ...info_up }]
						this.list.push({...info_up});
						this.total++;							
						this.actions_to_report("send_bus_info_to_table", {
							is_incident 		: this.ml.get("confirmed"),														
							color_incident 		: "success",
							user 				: info_up.username,
							date1 				: info_up.datee,
							type_incident 		: info_up.name,
							color_type_incident : "primary",
							color_incident 		: "success",
							Management_incident : [ ...this.list ],
							action_done 		: action_temp,

						});

					}


				}).catch(err => {
					this.loading_reports = false;

				})
			}, // action report

			action_descriptions(item){
				if (item) {
					if (this.info_incident && this.info_incident) {
						const api 				= this.$URL + "/api/v1/description_incident";
						let info_up 			= { ...this.info_incident };
						info_up.incidentId 		= info_up.id;
						if (info_up && info_up.id) {
							delete info_up.id;
						}
						info_up.description		= item;
						let temp_user 			= this.$store.getters["auth/user"];
						info_up.userId  		= temp_user && temp_user.user && temp_user.user ? temp_user.user.id : null ;
						info_up.username		= temp_user && temp_user.user && temp_user.user ? temp_user.user.Username : null ;
						info_up.date 			= "";
						this.loading_reports 	= true;
						
						this.$axios.post(api, info_up).then(res=>{
							this.loading_reports 	= false;

							let temp = info_up
							if (res && res.data) {
								info_up = { ...res.data };
								
							}
							info_up.datee = this.$Format.format_date(parseInt(info_up.date));
							info_up.username = temp.username;
							info_up.userId 	 = temp.userId;
							if (this.info_incident && !this.info_incident.descriptions) {
								this.info_incident.descriptions = [];
							}
							this.info_incident.descriptions.unshift(info_up);
							this.description = "";
							console.log("END added ", this.info_incident)
							
						}).catch(er => {
							this.loading_reports 	= false;
							console.log("Error create description ", er);
						})
					}else{
						console.warn("Required id of incidente " , this.info_incident)
					}
				}
			}, // action descriptions

			confirm_alert(){
				if (this.info_to_component && this.info_to_component.ID) {
					const api 	= this.$URL + "/api/v1/alert-confirm";
					let info_up = {
						eventId  		: this.info_to_component.ID,
						analytic 		: this.info_to_component.analytic,
						user 	 		: this.$store.getters["auth/user"],
						// name 			: this.$ml.get("incident"), 
					}
					this.loading_reports = true;
					this.$axios.post(api,info_up).then(res =>{
						this.loading_reports = false;
						if (res && res.data && res.data.id){
							info_up.id  					= res.data.id;
							info_up.name 					= res.data.name;
							info_up.date 					= res.data.date;
							info_up.datee 					= this.$Format.format_date(parseInt(info_up.date));
							info_up.userId  				= info_up && info_up.user && info_up.user.user ? info_up.user.user.id : null ;
							info_up.username				= info_up && info_up.user && info_up.user.user ? info_up.user.user.Username : null ;
							// this.show.actions 				= true;
							// this.show.table 				= false; 
							this.show.confirm 				= false;
							this.show.ignore  				= false;
							this.show.false_positive 		= false;						

							// this.show.descriptions 			= true;
							this.info_incident 				= {...info_up};

							// console.log("RESULT -------------__> ", info_up)
							info_up.action 					= "select_incident";
							let action_temp 				= "N/A";						
							if (res.data.descriptions && res.data.descriptions.length > 0) {
								info_up.descriptions = [...res.data.descriptions];			
								if (info_up.descriptions[0]) {
									action_temp  = info_up.descriptions[0].description;
								}					
							}
							this.info_incident.descriptions = [{ ...info_up }]
							this.list.push({...info_up});
							this.total++;
							this.actions_to_report("send_bus_info_to_table", {
								is_incident 		: this.$ml.get("confirmed"),
								color_incident 		: "success",
								alert_confirmed 	: this.$ml.get("confirmed"),
								is_confirmed 		: this.$ml.get("confirmed"),
								type_incident 		: info_up.name,
								color_type_incident : "success",
								user 				: info_up.username,
								date1 				: info_up.datee,
								color_confirmed 	: "success",
								Management_incident : [ ...this.list ],
								action_done 		: action_temp,

							});
						}
					}).catch(er => {
						this.loading_reports = false;
						console.warn("Error confirm Alert ", er);
						this.$EventBus.$emit("notifications_modal", {
							type 	: "warning",
							message : er
						})
					})
				}else{
					this.$EventBus.$emit("notifications_modal", {
						type 	: "warning",
						message : this.$ml.get("unable_to_send_event_id_not_found"),
					})		
				}
			}, // confirm_alert

			ignore_alert(){
				if (this.info_to_component && this.info_to_component.ID) {
					const api 	= this.$URL + "/api/v1/alert-ignore";
					let info_up = {
						eventId  		: this.info_to_component.ID,
						analytic 		: this.info_to_component.analytic,
						user 	 		: this.$store.getters["auth/user"],
					}; 
					this.loading_reports = true;
					this.$axios.post(api,info_up).then(res =>{
						this.loading_reports 			= false;
						this.show.confirm 				= false;
						this.show.ignore  				= false;
						this.show.false_positive 		= false;
						
						if (res && res.data){
							
							info_up.id  					= res.data.id;
							info_up.name 					= res.data.name;
							info_up.date 					= res.data.date;
							info_up.datee 					= this.$Format.format_date(parseInt(info_up.date));
							info_up.userId  				= info_up && info_up.user && info_up.user.user ? info_up.user.user.id : null ;
							info_up.username				= info_up && info_up.user && info_up.user.user ? info_up.user.user.Username : null ;
							this.info_incident 				= {...info_up};
							info_up.action 					= "select_incident";
							let action_temp 				= "N/A";
							if (res.data && res.data.descriptions && res.data.descriptions.length > 0) {
								info_up.descriptions = [...res.data.descriptions];	
								if (info_up.descriptions[0]) {
									action_temp  = info_up.descriptions[0].description;
								}						
							}
							this.info_incident.descriptions = [{ ...info_up }]
							this.list.push({...info_up});
							this.total++;
							
							let temp = {
								isignored 			: this.$ml.get("confirmed"),			
								is_incident 		: this.$ml.get("confirmed"),
								color_incident 		: "error",
								color_ignored 		: "error",
								type_incident 		: info_up.name,
								color_type_incident : "error",
								date1 				: info_up.datee,
								user 				: info_up && info_up.user && info_up.user.user ? info_up.user.user.Username : null,
								Management_incident : [ ...this.list ],
								action_done 		: action_temp,


							};												
							this.actions_to_report("send_bus_info_to_table", temp);
						}
					}).catch(er => {
						this.loading_reports = false;
						console.warn("Error ignore Alert ", er);
						this.$EventBus.$emit("notifications_modal", {
							type 	: "error",
							message : er,
						})
					})
				}else{
					this.$EventBus.$emit("notifications_modal", {
						type 	: "warning",
						message : this.$ml.get("unable_to_send_event_id_not_found"),
					});		
				}
			}, // ignore alert

			send_false_positive(){
				if (this.info_to_component && this.info_to_component.ID) {

					const api 	= this.$URL + "/api/v1/alert-fp";
					let info_up = {
						eventId  		: this.info_to_component.ID,
						analytic 		: this.info_to_component.analytic,
						user 	 		: this.$store.getters["auth/user"],
					}; 
					this.loading_reports = true;
					this.$axios.post(api,info_up).then(res =>{
						this.loading_reports 			= false;
						this.show.confirm 				= false;
						this.show.ignore  				= false;
						this.show.false_positive 		= false;
						// this.info_component.false_positive 	= true;
						
						if (res && res.data && res.data.id){
							info_up.id  					= res.data.id;
							info_up.name 					= res.data.name;
							info_up.date 					= res.data.date;
							info_up.datee 					= this.$Format.format_date(parseInt(info_up.date));
							info_up.userId  				= info_up && info_up.user && info_up.user.user ? info_up.user.user.id : null ;
							info_up.username				= info_up && info_up.user && info_up.user.user ? info_up.user.user.Username : null ;
							this.info_incident 				= {...info_up};

							info_up.action 	= "select_incident";
							let action_temp = "N/A";
							if (res.data && res.data.descriptions && res.data.descriptions.length > 0) {
								info_up.descriptions = [...res.data.descriptions];							
								if (info_up.descriptions[0]) {
									action_temp  = info_up.descriptions[0].description;
								}
							}
							this.info_incident.descriptions = [{ ...info_up }]
							this.list.push({...info_up});
							this.total++;
							let temp = {
								false_positive 		: this.$ml.get("confirmed"),			
								is_incident 		: this.$ml.get("confirmed"),			
								color_incident 		: "warning",
								color_fp 			: "warning",
								type_incident 		: info_up.name,
								color_type_incident : "warning",
								date1 				: info_up.datee,
								user 				: info_up.username,
								action_done 		: action_temp,
								Management_incident : [ ...this.list ],
							};												
							this.actions_to_report("send_bus_info_to_table", temp);
						}
					}).catch(er => {
						this.loading_reports = false;
						console.warn("Error false positive Alert ", er);
						this.$EventBus.$emit("notifications_modal", {
							type 	: "error",
							message : er,
						})		
					})
				}else{
					this.$EventBus.$emit("notifications_modal", {
						type 	: "warning",
						message : this.$ml.get("unable_to_send_event_id_not_found"),
					})		
				}
			}, // send false positive

			get_actions_reports(item){
				let url 			 = this.$URL + "/api/v1/management_incident/incidents";
				let info_up 		 = {
					eventId	 : item.ID,
					type 	 : item.analytic, 
				};
				this.loading_reports = true;
				this.$axios.post(url, info_up).then( res => {
					this.show.confirm  		= true;
					if (this.info_to_component && this.info_to_component.alert_confirmed) {
						this.show.confirm  		= false;
					}
					this.loading_reports 	= false;

					if (res && res.data && res.data.rows && res.data.rows.length > 0 ) {
						let list_temp = [];
						this.show.confirm  = false;
						res.data.rows.forEach((incd)=>{
							let tmp = this.$Format.render_incident(incd);
							if (tmp) {
								list_temp.push(tmp);
							}
						});
						// console.log("LIST description ***********************", list_temp)
						this.list 	= [...list_temp];
						this.total 	= res.data.count || list_temp.length;
						// this.list_actions[1].list = list_temp; 
					}
					// this.render_cols("reports"); 
					// this.info.reports = true;

				}).catch(err => {	
					this.loading_reports 	= false;
					this.show.confirm  		= true;					
					console.log("Error get list reports", err)
				})
			}, // get actions reports

			

			render_list_actions(){
	        	this.list_actions = [ ...default_list_actions ];
	        }, // render_list_actions
			
			

	}, // methods 
	
	mounted(){
		let temp_bus = "notifications_modal" + this.ID_notification;
		this.$EventBus.$on(temp_bus, this.bus[temp_bus] = (confirm, action)=>{
				console.log("action confirm ", this.ID_notification, confirm,action)
			if (confirm) {
				if (action) {
					if (action.action) {
						this.actions_to_report(action.action);
					}
				}else{

					let { action_confirm } 	=	this.info_item;
					this.actions_to_report("show_add");
					this.actions_to_report(action_confirm, confirm, this.info_item)
				}

			}else{
				if (!action) {
					this.actions_to_report("show_add");
				}

			}
		});
	}, // mounted

	beforeDestroy(){
		this.$Helper.clear_bus(this.$EventBus, this.bus, "Alert modal");
	}, // before destroy

}; // expor default
